import styled from "styled-components";
import { V3EmbedCollectionSeparator } from "../V3EmbedCollection";

export const SmartShareCreateCTAWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;

    > div {
        min-height: 18px;
        display: inline-flex;

        &:first-child {
            margin-right: 28px;
        }
    }
`;

export const SmartShareCreateHelpIcon = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;

    > div {
        display: inline-flex;
        
        &:first-child {
            margin-right: 6px;
        }
    }
`;

export const SmartShareHR = styled (V3EmbedCollectionSeparator)`
    margin: 0 -22px;
`;